import React from 'react'
import { AutomationRuleActionsEnum } from 'src/editor/shared/types/automation-rules/actions-types'
import { Tag02Icon } from 'src/editor/shared/icons/tag-02-icon'
import { Announcement03Icon } from 'src/editor/shared/icons/announcement-03-icon'
import { Tag02RemoveIcon } from 'src/editor/shared/icons/tag-02-remove-icon'
import { GraduationHat01Icon } from 'src/editor/shared/icons/graduation-hat-01-icon'
import { BookOpen01Icon } from 'src/editor/shared/icons/book-open-01-icon'
import { Send01Icon } from 'src/editor/shared/icons/send-01-icon'
import { LockUnlocked02Icon } from 'src/editor/shared/icons/lock-unlocked-02-icon'
import { Mail05Icon } from 'src/editor/shared/icons/mail-05-icon'
import { Mail01Icon } from 'src/editor/shared/icons/mail-01-icon'
import { Announcement03RemoveIcon } from 'src/editor/shared/icons/announcement-03-remove-icon'
import { GraduationHat01RemoveIcon } from 'src/editor/shared/icons/graduation-hat-01-remove-icon'
import { BookOpen01RemoveIcon } from 'src/editor/shared/icons/book-open-01-remove-icon'
import { LockUnlocked02RemoveIcon } from 'src/editor/shared/icons/lock-unlocked-02-remove-icon'
import { UserPlus02Icon } from 'src/editor/shared/icons/user-plus-02-icon'

export const getActionIcon = (action: AutomationRuleActionsEnum) => {
  switch (action) {
    case AutomationRuleActionsEnum.add_tag:
      return <Tag02Icon />
    case AutomationRuleActionsEnum.subscribe_to_campaign:
      return <Announcement03Icon />
    case AutomationRuleActionsEnum.send_email:
      return <Mail05Icon />
    case AutomationRuleActionsEnum.send_email_to_specific_address:
      return <Mail01Icon />
    case AutomationRuleActionsEnum.enroll_in_course:
      return <GraduationHat01Icon />
    case AutomationRuleActionsEnum.enroll_in_course_bundle:
      return <BookOpen01Icon />
    case AutomationRuleActionsEnum.send_webhook:
      return <Send01Icon />
    case AutomationRuleActionsEnum.grant_access_to_community:
      return <LockUnlocked02Icon />
    case AutomationRuleActionsEnum.remove_tag:
      return <Tag02RemoveIcon />
    case AutomationRuleActionsEnum.unsubscribe_from_campaign:
      return <Announcement03RemoveIcon />
    case AutomationRuleActionsEnum.revoke_access_to_course:
      return <GraduationHat01RemoveIcon />
    case AutomationRuleActionsEnum.revoke_access_to_course_bundle:
      return <BookOpen01RemoveIcon />
    case AutomationRuleActionsEnum.revoke_access_to_community:
      return <LockUnlocked02RemoveIcon />
    case AutomationRuleActionsEnum.create_user: {
      return <UserPlus02Icon />
    }
  }
}
